import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CommentThread"] */ "/opt/buildhome/repo/src/components/portal/CommentThread.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RequestActions"] */ "/opt/buildhome/repo/src/components/portal/RequestActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatusBadge"] */ "/opt/buildhome/repo/src/components/portal/StatusBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VoteButton"] */ "/opt/buildhome/repo/src/components/portal/VoteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/opt/buildhome/repo/src/components/ui/separator.tsx");
